import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class HuisVerkopen {
    constructor() {
        if (document.querySelector('#show.page-huisverkopen') !== null) {
            this.initReviews();
            this.initSteps();
        }

        this.initUsps();
    }

    initUsps() {
        if(!document.querySelector('#usps')) return;
        new Swiper('#usps .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                }
            }
        });
    }

    initReviews() {
        new Swiper('#reviews .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 60,
            navigation: {
                nextEl: '#reviews .swiper-button-next',
                prevEl: '#reviews .swiper-button-prev',
            }
        });
    }

    initSteps() {
        new Swiper('#process .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 60,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                }
            }
        });
    }

}
